/**
 * @desc 地区层级_V1
 */

import { RequestConfig, request } from 'umi';

function req(useless?: any, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.GeneralHttpResponse<Array<defs.store.AreaBigRpcDTO>>
  >(`/storeapi/inner/address/areas`, {
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.AreaBigRpcDTO>>;
export default req;
